export const REPORTS_DISPLAY_NAMES = {
  REPAYMENTS_ANALYTICS: 'Repayment Analytics',
  BILLING: 'Billing',
  CONSUMER_ECONOMICS: 'Consumer Economics',
  CONSUMER_ANALYTICS: 'Consumer Analytics',
  CONSUMER_HUBSPOT: ' Consumer HubSpot',
  ADVANCES_ANALYTICS: 'Advances Analytics',
  TRANSFERS_ANALYTICS: 'Transfers Analytics',
  SIGNUP_FUNNEL: 'Signup Funnel',
  GENERIC_SIGNUP: 'Generic Signup',
  RISK_INDICATORS: 'Risk Indicators',
  DETAILED_SIGNUP_FUNNEL: 'Detailed Signup Funnel',
  REFERRALS: 'Referrals',
  AGGREGATOR_MONTHLY: 'Aggregator Monthly',
  REWARDS: 'Rewards',
  LOGINS: 'Consumer Logins',
  OUTSTANDING_ADVANCES: 'Outstanding Advances',
  ENGAGEMENT: 'Consumers Engagement',
  SURVEYS: 'Surveys',
  LOSSES: 'Losses',
  REWARDS_LOG: 'Rewards Log',
  METRICS: 'Metrics',
  PROFITABILITY: 'Profitability',
  DOD: 'Day over Day (DOD)',
};

export const REPORTS_GROUPS = {
  Analytics: [
    'CONSUMER_ANALYTICS',
    'ADVANCES_ANALYTICS',
    'TRANSFERS_ANALYTICS',
    'REPAYMENTS_ANALYTICS',
    'METRICS',
    'DOD',
  ],
  Financial: [
    'AGGREGATOR_MONTHLY',
    'CONSUMER_ECONOMICS',
    'OUTSTANDING_ADVANCES',
    'LOSSES',
    'PROFITABILITY',
  ],
  Signup: ['SIGNUP_FUNNEL', 'DETAILED_SIGNUP_FUNNEL', 'GENERIC_SIGNUP'],
  Engagement: ['LOGINS', 'ENGAGEMENT', 'REFERRALS', 'REWARDS', 'SURVEYS', 'REWARDS_LOG'],
  Operations: ['CONSUMER_HUBSPOT', 'RISK_INDICATORS'],
};

export const REPORTS_STATUS_BADGE = {
  PENDING: { text: 'Pending', color: 'warning' },
  RUNNING: { text: 'Running', color: 'info' },
  READY: { text: 'Ready', color: 'success' },
  FAILED: { text: 'Failed', color: 'danger' },
};

// ---------------------------- REPORTS COLUMNS ----------------------------

export const ADVANCES_ANALYTICS_COLUMNS = {
  id: {
    header: 'Id',
    width: 12,
    style: { alignment: { horizontal: 'right' } },
  },
  aggregatorName: {
    header: 'Aggregator Name',
    width: 22,
    style: { alignment: { horizontal: 'left' } },
  },
  consumerId: {
    header: 'Consumer Id',
    width: 14,
    style: { alignment: { horizontal: 'right' } },
  },
  consumerFirstName: {
    header: 'First Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  consumerLastName: {
    header: 'Last Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  textualReason: {
    header: 'Reason',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  status: {
    header: 'Status',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  repaymentMode: {
    header: 'Repayment Mode',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  amount: {
    header: 'Amount',
    width: 18,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  initialAmount: {
    header: 'Initial amount',
    width: 18,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  topupAmount: {
    header: 'Top-ups amount',
    width: 18,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  numberOfTopups: {
    header: 'Number of top-ups',
    width: 20,
    style: { alignment: { horizontal: 'right' } },
  },
  numberOfRepayments: {
    header: 'Number of repayments',
    width: 24,
    style: { alignment: { horizontal: 'right' } },
  },
  numberOfCancelledRepayments: {
    header: 'Number of cancelled repayments',
    width: 30,
    style: { alignment: { horizontal: 'right' } },
  },
  repaymentTrials: {
    header: 'Repayment trials',
    width: 18,
    style: { alignment: { horizontal: 'right' } },
  },
  openTime: {
    header: 'Open time',
    width: 22,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  lastRepaymentDate: {
    header: 'Last Repayment Date',
    width: 23,
    style: { alignment: { horizontal: 'right' }, numFmt: 'yyyy-mm-dd' },
  },
  closeTime: {
    header: 'Close time',
    width: 23,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  usedBridgepoints: {
    header: 'Used Bridgepoints™',
    width: 34,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  remainingBridgepoints: {
    header: 'Remaining Bridgepoints™',
    width: 34,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  maxOfferAmount: {
    header: 'Max Offer Amount',
    width: 21,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  defaultofferAmount: {
    header: 'Default Offer Amount',
    width: 24,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  payrollLimit: {
    header: 'Payroll Limit',
    width: 16,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  bpLimit: {
    header: 'Bridgepoints™ Limit',
    width: 23,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
};

export const BILLING_COLUMNS = {
  consumerId: {
    header: 'Id',
    width: 12,
    style: { alignment: { horizontal: 'right' } },
  },
  firstName: {
    header: 'First Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  lastName: {
    header: 'Last Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  billableDays: {
    header: 'Billable Days',
    width: 16,
    style: { alignment: { horizontal: 'right' } },
  },
};

export const CONSUMER_ANALYTICS_COLUMNS = {
  id: {
    header: 'Id',
    width: 12,
    style: { alignment: { horizontal: 'right' } },
  },
  firstName: {
    header: 'First Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  lastName: {
    header: 'Last Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  registrationTime: {
    header: 'Registration Time',
    width: 22,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  aggregatorId: {
    header: 'Aggregator Id',
    width: 16,
    style: { alignment: { horizontal: 'right' } },
  },
  aggregatorName: {
    header: 'Aggregator Name',
    width: 22,
    style: { alignment: { horizontal: 'left' } },
  },
  status: {
    header: 'Status',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  advanceEligibility: {
    header: 'Advance Eligibility',
    width: 49,
    style: { alignment: { horizontal: 'left' } },
  },
  bankName: {
    header: 'Bank Name',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  bankAccountStatus: {
    header: 'Bank Account Status',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  dateOfBirth: {
    header: 'Date of Birth',
    width: 18,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd' },
  },
  language: {
    header: 'Language',
    width: 18,
    style: { alignment: { horizontal: 'left' } },
  },
  devicePlatform: {
    header: 'Mobile OS',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  firstLogin: {
    header: 'First Login',
    width: 22,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  lastLogin: {
    header: 'Last Login',
    width: 22,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  logins: {
    header: 'Logins',
    width: 16,
    style: { alignment: { horizontal: 'right' } },
  },
  signupLink: {
    header: 'Signup Link',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  profileDataTimestamp: {
    header: 'Profile Date/Time',
    width: 22,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  profileValidity: {
    header: 'Profile Status',
    width: 25,
    style: { alignment: { horizontal: 'left' } },
  },
  payrollFequency: {
    header: 'Payroll Frequency',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  nextPayroll: {
    header: 'Next Payroll',
    width: 18,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd' },
  },
  currentBalance: {
    header: 'Current Balance',
    width: 18,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  availableBalance: {
    header: 'Available Balance',
    width: 22,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  bpCurrentBalance: {
    header: 'Current Bridgepoints™ Balance',
    width: 34,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  bpAvailableBalance: {
    header: 'Available Bridgepoints™ Balance',
    width: 36,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  bpExtpectedBalanceOnAdvanceClose: {
    header: 'Expected Bridgepoints™ Balance On Advance Close',
    width: 40,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  offer: {
    header: 'Offer',
    width: 36,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  outstandingAdvance: {
    header: 'Outstanding Advance',
    width: 24,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
};

export const CONSUMER_ECONOMICS_COLUMNS = {
  consumerId: {
    header: 'Id',
    width: 12,
    style: { alignment: { horizontal: 'right' } },
  },
  firstName: {
    header: 'First Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  lastName: {
    header: 'Last Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  billableDays: {
    header: 'Billable Days',
    width: 16,
    style: { alignment: { horizontal: 'right' } },
  },
  periodRevenue: {
    header: 'Revenue',
    width: 16,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  activeDays: {
    header: 'Active Days',
    width: 16,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  creditDays: {
    header: 'Credit Days',
    width: 16,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  creditDaysPercent: {
    header: 'Credit Days (%)',
    width: 18,
    style: { alignment: { horizontal: 'right' }, numFmt: '0.00%' },
  },
  bridgePoints: {
    header: 'BridgePoints',
    width: 16,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  bridgePointsPerMonth: {
    header: 'BridgePoints/Month',
    width: 22,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  averageDailyOustrandingCredit: {
    header: 'Average Daily Outstanding Credit',
    width: 30,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  creditCost: {
    header: 'Credit Cost',
    width: 16,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  creditAch: {
    header: 'Credit ACH',
    width: 16,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  debitAch: {
    header: 'Debit ACH',
    width: 16,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  successfulAch: {
    header: 'Successful ACH',
    width: 18,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  failedAch: {
    header: 'Failed ACH',
    width: 16,
    style: { alignment: { horizontal: 'right' }, numFmt: '#,##0' },
  },
  achCost: {
    header: 'ACH Cost',
    width: 16,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  achFees: {
    header: 'ACH Fees',
    width: 16,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  monitoringCost: {
    header: 'Monitoring Cost',
    width: 18,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  estimatedDefaultCost: {
    header: 'Estimated Default Cost',
    width: 22,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  totalCost: {
    header: 'Total Cost',
    width: 16,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  totalMargin: {
    header: 'Total Margin',
    width: 16,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00;[Red]-"$"#,##0.00' },
  },
};

export const CONSUMER_HUBSPOT_COLUMNS = {
  hubspotCompanyRecordId: {
    header: 'Company Record ID',
    width: 22,
    style: { alignment: { horizontal: 'right' } },
  },
  id: {
    header: 'Consumer ID',
    width: 16,
    style: { alignment: { horizontal: 'right' } },
  },
  firstName: {
    header: 'First Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  lastName: {
    header: 'Last Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  email: {
    header: 'Email',
    width: 36,
    style: { alignment: { horizontal: 'left' } },
  },
  phone: {
    header: 'Phone',
    width: 20,
    style: { alignment: { horizontal: 'right' } },
  },
  streetAddress: {
    header: 'Street Address',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  streetAddress2: {
    header: 'Street Address 2',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  city: {
    header: 'City',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  state: {
    header: 'State',
    width: 10,
    style: { alignment: { horizontal: 'left' } },
  },
  zip: {
    header: 'Postal Code',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  country: {
    header: 'Country',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  employeeId: {
    header: 'Employee ID',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  dateOfBirth: {
    header: 'Date of Birth',
    width: 18,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd' },
  },
  last4ssn: {
    header: 'Last 4 digits of SSN',
    width: 22,
    style: { alignment: { horizontal: 'right' } },
  },
  registrationDate: {
    header: 'Registration Date',
    width: 20,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd' },
  },
  status: {
    header: 'Status',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  bankName: {
    header: 'Bank Name',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  bankAccountStatus: {
    header: 'Bank Account Status',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  bankCategory: {
    header: 'Bank Category',
    width: 18,
    style: { alignment: { horizontal: 'left' } },
  },
  contactOwner: {
    header: 'Contact Owner',
    width: 36,
    style: { alignment: { horizontal: 'left' } },
  },
  lifecycleStage: {
    header: 'Lifecycle Stage',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  b2cType: {
    header: 'B2C Type',
    width: 18,
    style: { alignment: { horizontal: 'left' } },
  },
  marketingContactStatus: {
    header: 'Marketing Contact Status',
    width: 26,
    style: { alignment: { horizontal: 'left' } },
  },
};

export const LOGINS_COLUMNS = {
  aggregatorName: {
    header: 'Aggregator Name',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  consumerId: {
    header: 'Consumer ID',
    width: 16,
    style: { alignment: { horizontal: 'right' } },
  },
  firstName: {
    header: 'First Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  lastName: {
    header: 'Last Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  timestamp: {
    header: 'Login Time',
    width: 23,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  version: {
    header: 'Mobile App Version',
    width: 23,
    style: { alignment: { horizontal: 'left' } },
  },
};

export const DETAILED_SIGNUP_FUNNEL_COLUMNS = {
  estTime: {
    header: 'Time (EST)',
    width: 23,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  ip: {
    header: 'IP Address',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  ipLocation: {
    header: 'IP Location',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  aggregatorName: {
    header: 'Aggregator',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  consumerId: {
    header: 'Consumer ID',
    width: 20,
    style: { alignment: { horizontal: 'right' } },
  },
  name: {
    header: 'Name',
    width: 22,
    style: { alignment: { horizontal: 'left' } },
  },
  email: {
    header: 'Email',
    width: 36,
    style: { alignment: { horizontal: 'left' } },
  },
  openLink: {
    header: 'Open Link',
    width: 28,
    style: { alignment: { horizontal: 'left' } },
  },
  page1: {
    header: 'Details Page 1',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  page2: {
    header: 'Details Page 2',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  verification: {
    header: 'Email Verification',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  consumer: {
    header: 'Consumer Created',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  account: {
    header: 'Account Linked',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  sessionId: {
    header: 'Session ID',
    width: 40,
    style: { alignment: { horizontal: 'left' } },
  },
  timestamp: {
    header: 'timestamp',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  eventName: {
    header: 'eventName',
    headerBgColor: '#DADADA',
    width: 25,
    style: { alignment: { horizontal: 'left' } },
  },
  view_name: {
    header: 'view_name',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  institution_id: {
    header: 'institution_id',
    headerBgColor: '#DADADA',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  institution_name: {
    header: 'institution_name',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  institution_search_query: {
    header: 'institution_search_query',
    headerBgColor: '#DADADA',
    width: 28,
    style: { alignment: { horizontal: 'left' } },
  },
  error_code: {
    header: 'error_code',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  error_message: {
    header: 'error_message',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  error_type: {
    header: 'error_type',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  exit_status: {
    header: 'exit_status',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  request_id: {
    header: 'request_id',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  link_session_id: {
    header: 'link_session_id',
    headerBgColor: '#DADADA',
    width: 44,
    style: { alignment: { horizontal: 'left' } },
  },
  mfa_type: {
    header: 'mfa_type',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  selection: {
    header: 'selection',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  brand_name: {
    header: 'brand_name',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  match_reason: {
    header: 'match_reason',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  routing_number: {
    header: 'routing_number',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  account_number_mask: {
    header: 'account_number_mask',
    headerBgColor: '#DADADA',
    width: 26,
    style: { alignment: { horizontal: 'left' } },
  },
  view_variant: {
    header: 'view_variant',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  is_update_mode: {
    header: 'is_update_mode',
    headerBgColor: '#DADADA',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
};

export const ENGAGEMENT_COLUMNS = {
  consumerId: {
    header: 'Consumer ID',
    width: 16,
    style: { alignment: { horizontal: 'right' } },
  },
  firstName: {
    header: 'First Name',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  lastName: {
    header: 'Last Name',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  aggregator: {
    header: 'Aggregator Name',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  billable: {
    header: 'Billable',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  signup: {
    header: 'Signup',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  logins: {
    header: 'Logins',
    width: 20,
    style: { alignment: { horizontal: 'right' } },
  },
  openAdvances: {
    header: 'Open Advances',
    width: 20,
    style: { alignment: { horizontal: 'right' } },
  },
  engaged: {
    header: 'Engaged',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
};

export const GENERIC_SIGNUP_COLUMNS = {
  timestamp: {
    header: 'Date and Time',
    width: 25,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  employerName: {
    header: 'Employer Name',
    width: 32,
    style: { alignment: { horizontal: 'left' } },
  },
  firstName: {
    header: 'First Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  lastName: {
    header: 'Last Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  email: {
    header: 'Email',
    width: 36,
    style: { alignment: { horizontal: 'left' } },
  },
  consent: {
    header: 'Consent',
    width: 23,
    style: { alignment: { horizontal: 'left' } },
  },
};

export const OUTSTANDING_ADVANCES_COLUMNS = {
  advanceId: {
    header: 'Advance ID',
    width: 18,
    style: { alignment: { horizontal: 'right' } },
  },
  aggregatorName: {
    header: 'Aggregator Name',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  consumerId: {
    header: 'Consumer ID',
    width: 16,
    style: { alignment: { horizontal: 'right' } },
  },
  consumerFirstName: {
    header: 'First Name',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  consumerLastName: {
    header: 'Last Name',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  status: {
    header: 'Advance Status',
    width: 19,
    style: { alignment: { horizontal: 'left' } },
  },
  amount: {
    header: 'Full Amount',
    width: 18,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  outstandingAmount: {
    header: 'Outstanding Amount',
    width: 23,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
};

export const REFERRALS_COLUMNS = {
  aggregatorName: {
    header: 'Aggregator Name',
    width: 22,
    style: { alignment: { horizontal: 'left' } },
  },
  referralId: {
    header: 'Referral Id',
    width: 18,
    style: { alignment: { horizontal: 'right' } },
  },
  referralFirstName: {
    header: 'Referral First Name',
    width: 23,
    style: { alignment: { horizontal: 'left' } },
  },
  referralLastName: {
    header: 'Referral Last Name',
    width: 23,
    style: { alignment: { horizontal: 'left' } },
  },
  refereeId: {
    header: 'Referee ID',
    width: 18,
    style: { alignment: { horizontal: 'right' } },
  },
  refereeFirstName: {
    header: 'Referee First Name',
    width: 23,
    style: { alignment: { horizontal: 'left' } },
  },
  refereeLastName: {
    header: 'Referee Last Name',
    width: 23,
    style: { alignment: { horizontal: 'left' } },
  },
  signupDate: {
    header: 'Referee Signup Date',
    width: 23,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd' },
  },
};

export const REPAYMENTS_ANALYTICS_COLUMNS = {
  job: {
    header: 'Job',
    width: 12,
    style: { alignment: { horizontal: 'left' } },
  },
  trialTimestamp: {
    header: 'Time',
    width: 22,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  blind: {
    header: 'Is Blind',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  aggregatorName: {
    header: 'Aggregator Name',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  consumerId: {
    header: 'Consumer ID',
    width: 18,
    style: { alignment: { horizontal: 'right' } },
  },
  consumerName: {
    header: 'Consumer Name',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  advanceId: {
    header: 'Advance ID',
    width: 18,
    style: { alignment: { horizontal: 'right' } },
  },
  preTrialAdvanceStatus: {
    header: 'Advance Status',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  preTrialRepaymentMode: {
    header: 'Advance Repayment Mode',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  expectedAmount: {
    header: 'Expected Amount',
    width: 26,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#' },
  },
  outstandingAmount: {
    header: 'Outstanding amount',
    width: 26,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#' },
  },
  repaymentType: {
    header: 'Repayment Type',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
  actionTaken: {
    header: 'Action Taken',
    width: 25,
    style: { alignment: { horizontal: 'left' } },
  },
  reason: {
    header: 'Reason',
    width: 40,
    style: { alignment: { horizontal: 'left' } },
  },
  reschedule: {
    header: 'Reschedule',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  actualAmount: {
    header: 'Actual amount',
    headerBgColor: '#f3a83c',
    width: 22,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#' },
  },
  fee: {
    header: 'Fee',
    headerBgColor: '#f3a83c',
    width: 18,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  transferType: {
    header: 'Payment Method',
    headerBgColor: '#f3a83c',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  transferStatus: {
    header: 'Transfer Status',
    headerBgColor: '#f3a83c',
    width: 22,
    style: { alignment: { horizontal: 'left' } },
  },
  failureReason: {
    header: 'Failure Reason',
    headerBgColor: '#f3a83c',
    width: 28,
    style: { alignment: { horizontal: 'left' } },
  },
  postTransferAction: {
    header: 'Post Transfer Action',
    headerBgColor: '#f3a83c',
    width: 24,
    style: { alignment: { horizontal: 'left' } },
  },
};

export const REWARDS_COLUMNS = {
  aggregatorName: {
    header: 'Aggregator Name',
    width: 23,
    style: { alignment: { horizontal: 'left' } },
  },
  consumerId: {
    header: 'Consumer ID',
    width: 16,
    style: { alignment: { horizontal: 'right' } },
  },
  firstName: {
    header: 'First Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  lastName: {
    header: 'Last Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  category: {
    header: 'Category',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  name: {
    header: 'Reward Name',
    width: 50,
    style: { alignment: { horizontal: 'left' } },
  },
  status: {
    header: 'Status',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  offerDate: {
    header: 'Offer Date',
    width: 22,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd' },
  },
  readCounter: {
    header: 'Read/Watch',
    width: 16,
    style: { alignment: { horizontal: 'left', wrapText: true } },
  },
  subscriptionDate: {
    header: 'Subscription Date',
    width: 22,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd' },
  },
  result: {
    header: 'Results',
    width: 36,
    style: { alignment: { horizontal: 'left', wrapText: true } },
  },
  closeDate: {
    header: 'Close Date',
    width: 22,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd' },
  },
};

export const REWARDS_LOG_COLUMNS = {
  timestamp: {
    header: 'Timestamp',
    width: 22,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  aggregatorName: {
    header: 'Aggregator Name',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  consumerId: {
    header: 'Consumer ID',
    width: 16,
    style: { alignment: { horizontal: 'right' } },
  },
  category: {
    header: 'Category',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  rewardType: {
    header: 'Type',
    width: 36,
    style: { alignment: { horizontal: 'left' } },
  },
  rewardId: {
    header: 'Reward ID',
    width: 40,
    style: { alignment: { horizontal: 'left' } },
  },
  description: {
    header: 'Event Description',
    width: 50,
    style: { alignment: { horizontal: 'left', wrapText: true } },
  },
};

export const RISK_INDICATORS_COLUMNS = {
  aggregatorName: {
    header: 'Aggregator Name',
    width: 23,
    style: { alignment: { horizontal: 'left' } },
  },
  consumerId: {
    header: 'Consumer ID',
    width: 16,
    style: { alignment: { horizontal: 'right' } },
  },
  firstName: {
    header: 'First Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  lastName: {
    header: 'Last Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  status: {
    header: 'Status',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  el_c_value: {
    header: 'External loans count',
    width: 22,
    style: { alignment: { horizontal: 'right' } },
  },
  el_s_value: {
    header: 'External loans sum',
    width: 22,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  el_p_value: {
    header: 'External loan providers',
    width: 25,
    style: { alignment: { horizontal: 'right' } },
  },
  pd_eod_value: {
    header: 'Payday EOD balance',
    width: 23,
    style: { alignment: { horizontal: 'right' }, numFmt: '0.00%' },
  },
  pd_plus1_eod_value: {
    header: 'Payday+1 EOD balance',
    width: 25,
    style: { alignment: { horizontal: 'right' }, numFmt: '0.00%' },
  },
  pd_debit_value: {
    header: 'Payday Debit transactions',
    width: 28,
    style: { alignment: { horizontal: 'right' }, numFmt: '0.00%' },
  },
  pd_plus1_debit_value: {
    header: 'Payday+1 Debit transactions',
    width: 30,
    style: { alignment: { horizontal: 'right' }, numFmt: '0.00%' },
  },
  od_nsf_value: {
    header: 'OD/NSF transactions',
    width: 22,
    style: { alignment: { horizontal: 'right' } },
  },
  nbd_value: {
    header: 'Negative balance days',
    width: 24,
    style: { alignment: { horizontal: 'right' }, numFmt: '0.00%' },
  },
  nbd_c_value: {
    header: 'Consecutive negative balance days',
    width: 36,
    style: { alignment: { horizontal: 'right' } },
  },
  el_c_threshold: {
    header: 'ELC Threshold',
    width: 22,
    style: { alignment: { horizontal: 'right' } },
    hidden: true,
  },
  el_s_threshold: {
    header: 'ELS Threshold',
    width: 22,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
    hidden: true,
  },
  el_p_threshold: {
    header: 'ELP Threshold',
    width: 22,
    style: { alignment: { horizontal: 'right' } },
    hidden: true,
  },
  pd_eod_threshold: {
    header: 'PD EOD Threshold',
    width: 22,
    style: { alignment: { horizontal: 'right' }, numFmt: '0.00%' },
    hidden: true,
  },
  pd_plus1_eod_threshold: {
    header: 'PD+1 EOD Threshold',
    width: 22,
    style: { alignment: { horizontal: 'right' }, numFmt: '0.00%' },
    hidden: true,
  },
  pd_debit_threshold: {
    header: 'PD Debit Threshold',
    width: 23,
    style: { alignment: { horizontal: 'right' }, numFmt: '0.00%' },
    hidden: true,
  },
  pd_plus1_debit_threshold: {
    header: 'PD+1 Debit Threshold',
    width: 23,
    style: { alignment: { horizontal: 'right' }, numFmt: '0.00%' },
    hidden: true,
  },
  od_nsf_threshold: {
    header: 'OD/NSF Threshold',
    width: 22,
    style: { alignment: { horizontal: 'right' } },
    hidden: true,
  },
  nbd_threshold: {
    header: 'NBD Threshold',
    width: 22,
    style: { alignment: { horizontal: 'right' }, numFmt: '0.00%' },
    hidden: true,
  },
  nbd_c_threshold: {
    header: 'NBDC Threshold',
    width: 22,
    style: { alignment: { horizontal: 'right' } },
    hidden: true,
  },
};

export const SIGNUP_FUNNEL_COLUMNS = {
  aggId: {
    header: 'Aggregator Id',
    width: 16,
    style: { alignment: { horizontal: 'right' } },
  },
  aggName: {
    header: 'Aggregator Name',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  openSignupLink: {
    header: 'Open Signup Link',
    width: 22,
    style: { alignment: { horizontal: 'right' } },
  },
  consumerCreated: {
    header: 'Consumer Created',
    width: 22,
    style: { alignment: { horizontal: 'right' } },
  },
  accountLinkCompleted: {
    header: 'Bank Account Linked',
    width: 23,
    style: { alignment: { horizontal: 'right' } },
  },
};

export const SURVEYS_COLUMNS = {
  aggregatorName: {
    header: 'Aggregator Name',
    width: 30,
    style: { alignment: { horizontal: 'left' } },
  },
  consumerId: {
    header: 'Consumer ID',
    width: 16,
    style: { alignment: { horizontal: 'right' } },
  },
  firstName: {
    header: 'First Name',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  lastName: {
    header: 'Last Name',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  date: {
    header: 'Date',
    width: 24,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  questionId: {
    header: 'Question ID',
    width: 18,
    style: { alignment: { horizontal: 'left' } },
  },
  questionText: {
    header: 'Question Text',
    width: 36,
    style: { alignment: { horizontal: 'left' } },
  },
  questionType: {
    header: 'Question Type',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  answerId: {
    header: 'Answer ID',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  answerText: {
    header: 'Answer Text',
    width: 32,
    style: { alignment: { horizontal: 'left' } },
  },
};

export const TRANSFERS_ANALYTICS_COLUMNS = {
  id: {
    header: 'Id',
    width: 12,
    style: { alignment: { horizontal: 'right' } },
  },
  fundingId: {
    header: 'Advance Id',
    width: 14,
    style: { alignment: { horizontal: 'right' } },
  },
  advanceRepaymentMode: {
    header: 'Advance Repayment Mode',
    width: 28,
    style: { alignment: { horizontal: 'left' } },
  },
  aggregatorName: {
    header: 'Aggregator Name',
    width: 22,
    style: { alignment: { horizontal: 'left' } },
  },
  consumerId: {
    header: 'Consumer Id',
    width: 15,
    style: { alignment: { horizontal: 'right' } },
  },
  consumerFirstName: {
    header: 'First Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  consumerLastName: {
    header: 'Last Name',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  direction: {
    header: 'Direction',
    width: 16,
    style: { alignment: { horizontal: 'left' } },
  },
  amount: {
    header: 'Amount',
    width: 18,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  fee: {
    header: 'Fee',
    width: 18,
    style: { alignment: { horizontal: 'right' }, numFmt: '"$"#,##0.00' },
  },
  status: {
    header: 'Status',
    width: 18,
    style: { alignment: { horizontal: 'left' } },
  },
  failureReason: {
    header: 'Failure Reason',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  provider: {
    header: 'Provider',
    width: 18,
    style: { alignment: { horizontal: 'left' } },
  },
  type: {
    header: 'Type',
    width: 20,
    style: { alignment: { horizontal: 'left' } },
  },
  reconciled: {
    header: 'Reconciled',
    width: 18,
    style: { alignment: { horizontal: 'left' } },
  },
  createTime: {
    header: 'Create Time',
    width: 22,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  confirmTime: {
    header: 'Confirm Time',
    width: 22,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  failTime: {
    header: 'Fail Time',
    width: 22,
    style: { alignment: { horizontal: 'left' }, numFmt: 'yyyy-mm-dd hh:mm:ss' },
  },
  user: {
    header: 'User',
    width: 36,
    style: { alignment: { horizontal: 'left' } },
  },
};
